export default __webpack_public_path__ + "static/media/640_dummy2016-physiotherapie01-mobile-de.56f52da8.png";